import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IMdbError } from '../../../errorObjects/MdbError';

// export interface IFetchThemeSpecsFailureState {
//   value: IMdbError | null
// }

const initialState: IMdbError | null = null;

export const fetchThemeSpecsFailureSlice = createSlice({
  name: 'fetchThemeSpecsFailure',
  initialState,
  reducers: {
    setFetchThemeSpecsFailure: (state: IMdbError | null, action: PayloadAction<IMdbError>) => {
      state = action.payload;
    },
    clearFetchThemeSpecsFailure: (state: IMdbError | null) => {
      state = null;
    },
  },
})

// Action creators are generated for each function in reducer)
export const { setFetchThemeSpecsFailure, clearFetchThemeSpecsFailure } = fetchThemeSpecsFailureSlice.actions;

// export the core reducer for the slice
export const fetchThemeSpecsFailureReducer = fetchThemeSpecsFailureSlice.reducer;

export default fetchThemeSpecsFailureSlice.reducer;